export const getWalletAddress = (state) => state.wallet.walletAddress;
